import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import TreatmentContent from '../components/TreatmentContent';

const PeriodontalTreatment = () => {
  return (
    <div className="periodontal-diagnosis-container" style={{ backgroundColor: "#edffee" }}>
      <Header />
      <TreatmentContent />
      <Footer />
    </div>
    );
};

export default PeriodontalTreatment;